<template>
    <div class="wrap-content">
        <!-- <p class="title-logo">MetalX</p> -->
        <img src="../assets/abi-vertical.png" alt="" class="img-title" />
        <div class="hello">
            <div class="content-left">
                <p class="brand">Reset password</p>
            </div>
            <div class="content-right">
                <form @submit.prevent="resetPassword">
                    <div class="form-group">
                        <label for="">Password</label>
                        <input type="password" class="form-input" placeholder="Masukkan password anda" v-model.trim="$v.form.password.$model" />
                        <div v-if="$v.form.password.$error">
                            <div class="error" v-if="!$v.form.password.required">
                                Password tidak boleh kosong
                            </div>
                            <div class="error" v-if="!$v.form.password.minLength">
                                Password minimal 8 karakter
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="">Ulangi Password</label>
                        <input type="password" class="form-input" placeholder="Masukkan ulangi password anda" v-model.trim="$v.form.confirm_password.$model" />
                        <div v-if="$v.form.confirm_password.$error">
                            <div class="error" v-if="!$v.form.confirm_password.required">
                                Password tidak boleh kosong
                            </div>
                            <div class="error" v-if="!$v.form.confirm_password.minLength">
                                Password minimal 8 karakter
                            </div>
                        </div>
                    </div>
                    <div class="error" v-show="status == 401">
                        Password tidak sama, silahkan masukkan ulang password
                    </div>
                    <button class="btn-primer">
                        <div v-show="isLoading == false">Submit</div>
                        <Loading v-show="isLoading" />
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import axios from "axios";
import Loading from "../assets/Loading.vue";
export default {
    components: {
        Loading,
    },
    data() {
        return {
            email: "",
            status: "",
            form: {
                password: "",
                confirm_password: "",
            },
            token: "",
            isLoading: false,
        };
    },
    validations: {
        form: {
            password: {
                required,
                minLength: minLength(8),
            },
            confirm_password: {
                required,
                minLength: minLength(8),
            },
        },
    },
    created() {
        let id = this.$route.params.id;
        this.token = id;
        axios.get("/v1/user/reset/" + id).then((res) => {
            this.email = res.data.data.email;
        });
        // window.location.href = "/login";
    },
    methods: {
        resetPassword() {
            this.$v.form.$touch();
            if (this.$v.form.$error) {
                return;
            }
            let data = {
                password: this.form.password,
                // email: this.email,
                token: this.token,
            };
            this.isLoading = true;

            if (this.form.password == this.form.confirm_password) {
                axios
                    .put("/v2/user/reset/password", data)
                    .then((res) => {
                        this.status = res.status;
                        if (res.status == 200) {
                            this.$notify({
                                group: "foo",
                                title: "<h5>Password berhasil dirubah</h5>",
                                type: "success",
                                duration: 2000,
                            });
                            setTimeout(() => this.$router.push("/login"), 2000);
                        }

                        this.isLoading = false;
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        this.status = error.response.status;
                    });
            } else {
                this.status = 401;
                this.isLoading = false;
            }
        },
    },
};
</script>

<style scoped>
label {
    display: block;
}
.wrap-content {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: rgba(197, 151, 51, 0.4);
}

.title-logo {
    position: relative;
    top: -30px;
    font-size: 45px;
    font-weight: bold;
    color: #1e354a;
}

.img-title {
    height: 98px;
    margin-bottom: 40px;
}

.hello {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.content-left {
    background: #1e354a;
    color: white;
    width: 43%;
    padding: 10px 15px;
    border-radius: 5px 5px 0 0;
    text-align: center;
}

.content-right {
    width: 46%;
    background: white;
    border-radius: 5px;
    padding: 20px 45px;
    box-shadow: 0px 8px 20px 0px rgb(0 0 0 / 15%);
}

.form-input {
    width: 100%;
    height: 50px;
}

.brand {
    font-size: 25px;
    font-weight: bold;
    margin: 0 0;
}

.notice {
    height: 17px;
    font-size: 12px;
    font-weight: bold;
    margin: -19px 0 35px 15px;
    color: rgba(112, 112, 112, 0.7);
}

@media (max-width: 768px) {
    .content-left {
        width: 80%;
    }

    .content-right {
        width: 90%;
        padding: 1rem 1.5rem;
    }

    .img-title {
        height: 4rem;
    }
}
</style>
